"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trapezoid = void 0;
var figureBase_1 = require("../../../core/base/figureBase");
var line3_1 = require("../../../core/base/line3");
var three_1 = require("three");
var Trapezoid = /** @class */ (function (_super) {
    __extends(Trapezoid, _super);
    function Trapezoid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Trapezoid.prototype.calculateConnectionIndexes = function () {
        return [0, 1, 2, 3, 4];
    };
    Trapezoid.prototype.calculateHoleLines = function () {
        return [];
    };
    Trapezoid.prototype.calculateLines = function () {
        var coords = this.config.options;
        var aPoint = new three_1.Vector3(coords.wBottom / 2, 0);
        var bPoint = new three_1.Vector3(-coords.wBottom / 2, 0);
        var cPoint = new three_1.Vector3(-coords.wBottom / 2, coords.hBottom + coords.hTop);
        var dPoint = new three_1.Vector3(-coords.wBottom / 2 + coords.wTop, coords.hBottom + coords.hTop);
        var ePoint = new three_1.Vector3(coords.wBottom / 2, coords.hBottom);
        return [new line3_1.Line3(line3_1.LineType.Straight, [aPoint, bPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [bPoint, cPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [cPoint, dPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [dPoint, ePoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [ePoint, aPoint]),
        ];
    };
    Trapezoid.prototype.getConfigProperties = function () {
        return {
            wTop: 0.7,
            wBottom: 1,
            hTop: 0.7,
            hBottom: 0.3
        };
    };
    return Trapezoid;
}(figureBase_1.FigureBase));
exports.Trapezoid = Trapezoid;
